import React from 'react';
import { Link } from 'react-router-dom';
const Schedule = (item) => {
  // map
  // console.log(item?.item);

  return (
    <div className='grid grid-cols-4 border-r-2 '>
      {item?.item?.map((time, item) => (
        <div
          className=' '
          key={item}
        >
          <div className='border-r-2 border-[#39353c]  '>
            <div className='bg-colorFour'>
              <p className='text-xs text-white  py-5 w-full'>
                {time?.date_name} <br />
                {time?.date}
              </p>
            </div>

            {time.slot.map((timeSlot, item) => (
              <span
                className='timeSlot mx-1'
                key={item}
              >
                {timeSlot?.time}
              </span>
            ))}

            <br />
            <Link
              to='/buy-ticket'
              className='customBtn2 text-[12px] py-1 my-4'
            >
              Get Ticket
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Schedule;
